import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import TenderForm from '../components/TenderForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';



const CellActions = (props) =>{
    return(
        <>
            <Link to={`/tender/details/${props.data.id}`}>{props.data.title}</Link>
            {/*

            <TenderForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
  }


function TenderDashboardPage() {

  
  const {getDDDataById,companyDD, getMasterLabel} = useAppData();
  const {tenderList,getTenderList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {headerName: "Company", width:200,
          valueGetter:params=>{
            return getDDDataById(companyDD,params.data.companyId).label;
          }
        }, 
        {headerName:"Title", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getTenderList,
                remove:remove
            },
        },
        {headerName: "Type",
          valueGetter:params=>{
            return getMasterLabel("tender-type",params.data.tenderType);
          }
        },
        
        {field:"tenderNo",headerName: "Tender No",width:250},
        {field:"workLocation",headerName: "Work Location",width:200},
        {field:"tenderAmount",headerName: "T.Amount"},
        {field:"bidAmount",headerName: "B.Amount",},
        
        {field:"gstRate",headerName: "GST"},
        
              
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Tender</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><TenderForm callBack={getTenderList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 600}}>
              <AgGridReact
                ref={gridRef}
                rowData={tenderList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getTenderList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default TenderDashboardPage